import { render, staticRenderFns } from "./HowThisWorksScreen.vue?vue&type=template&id=471580c4&"
import script from "./HowThisWorksScreen.vue?vue&type=script&lang=js&"
export * from "./HowThisWorksScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports